<app-header *ngIf="showHeaderAndFooter"></app-header>
<main [class.pt-14]="showHeaderAndFooter">
  <router-outlet></router-outlet>
</main>
<app-footer *ngIf="showHeaderAndFooter"></app-footer>
